import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=5c0558cf&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=5c0558cf&prod&lang=less&scoped=true"
import style1 from "./SideMenu.vue?vue&type=style&index=1&id=5c0558cf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0558cf",
  null
  
)

export default component.exports